<template>
    <div class="evn-domains">
        <el-tag v-for="(item, index) in list" class="x-overflow-hidden" type="info" :key="index" size="mini">{{$opt.switchStr(item, $opt.env)}}</el-tag>
    </div>
</template>

<script>
    export default {
      props: {
        list: {
          type: Array,
          default: () => {
            return [];
          }
        },
      },
    };
</script>

<style lang="scss" scoped>
    .evn-domains {
        display: flex;
        flex-direction: column;

        .el-tag--mini {
            height: auto;
            padding: 2px 5px;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>